'use strict';

const PLUGINS = {
	ABIDE: 'ABIDE',
	ACCORDION: 'ACCORDION',
	DROPDOWN: 'DROPDOWN',
	DROPDOWN_MENU: 'DROPDOWN_MENU',
	EQUALIZER: 'EQUALIZER',
	OFF_CANVAS: 'OFF_CANVAS',
	ORBIT: 'ORBIT',
	REVEAL: 'REVEAL',
	TABS: 'TABS'
};

let pluginsToLoad = [];
let loadedPlugins = [];
let initialLoadComplete = false;

function importPlugin(plugin) {
	switch (plugin) {
		case PLUGINS.ABIDE:
			import(/* webpackChunkName: "foundation-abide" */ 'foundation-sites/js/foundation.abide').then(function ({ Abide }) {
				Foundation.plugin(Abide, 'Abide');
				processNextPlugin();
			});
			break;

		case PLUGINS.ACCORDION:
			import(/* webpackChunkName: "foundation-accordion" */ 'foundation-sites/js/foundation.accordion').then(function({Accordion}) {
				Foundation.plugin(Accordion, 'Accordion');
				processNextPlugin();
			});
			break;

		case PLUGINS.DROPDOWN:
			import(/* webpackChunkName: "foundation-dropdown" */ 'foundation-sites/js/foundation.dropdown').then(function({Dropdown}) {
				Foundation.plugin(Dropdown, 'Dropdown');
				processNextPlugin();
			});
			break;

		case PLUGINS.DROPDOWN_MENU:
			import(/* webpackChunkName: "foundation-dropdownMenu" */ 'foundation-sites/js/foundation.dropdownMenu').then(function({DropdownMenu}) {
				Foundation.plugin(DropdownMenu, 'DropdownMenu');
				processNextPlugin();
			});
			break;

		case PLUGINS.EQUALIZER:
			import(/* webpackChunkName: "foundation-equalizer" */ 'foundation-sites/js/foundation.equalizer').then(function({Equalizer}) {
				Foundation.plugin(Equalizer, 'Equalizer');
				processNextPlugin();
			});
			break;

		case PLUGINS.OFF_CANVAS:
			import(/* webpackChunkName: "foundation" */ 'foundation-sites/js/foundation.offcanvas').then(function({OffCanvas}) {
				Foundation.plugin(OffCanvas, 'OffCanvas');
				processNextPlugin();
			});
			break;

		case PLUGINS.ORBIT:
			import(/* webpackChunkName: "foundation-orbit" */ 'foundation-sites/js/foundation.orbit').then(function({Orbit}) {
				Foundation.plugin(Orbit, 'Orbit');
				processNextPlugin();
			});
			break;

		case PLUGINS.REVEAL:
			import(/* webpackChunkName: "foundation-reveal" */ 'foundation-sites/js/foundation.reveal').then(function({Reveal}) {
				Foundation.plugin(Reveal, 'Reveal');
				processNextPlugin();
			});
			break;

		case PLUGINS.STICKY:
			import(/* webpackChunkName: "foundation" */ 'foundation-sites/js/foundation.sticky').then(function({Sticky}) {
				Foundation.plugin(Sticky, 'Sticky');
				processNextPlugin();
			});
			break;

		case PLUGINS.TABS:
			import(/* webpackChunkName: "foundation-tabs" */ 'foundation-sites/js/foundation.tabs').then(function({Tabs}) {
				Foundation.plugin(Tabs, 'Tabs');
				processNextPlugin();
			});
			break;
	}
}

function processNextPlugin() {
	if (pluginsToLoad.length > 0) {
		let plugin = pluginsToLoad.shift();

		if (loadedPlugins.includes(plugin)) {
			processNextPlugin();
		} else {
			loadedPlugins.push(plugin);
			importPlugin(plugin);
		}
	} else {
		initialLoadComplete = true;
		$(document).foundation();
	}
}

export default {
	loadFoundation(callback) {
		import(/* webpackChunkName: "foundation" */ 'foundation-sites/js/foundation.core').then(function() {
			Foundation.addToJquery($);

			pluginsToLoad = pluginsToLoad.concat([
				PLUGINS.DROPDOWN_MENU,
				PLUGINS.OFF_CANVAS,
				PLUGINS.STICKY
			]);

			processNextPlugin();
			callback();
		}).catch(error => 'An error occurred while loading the foundation component:' + error);
	},

	addPlugins(plugins) {
		pluginsToLoad = pluginsToLoad.concat(plugins);

		if (initialLoadComplete) {
			processNextPlugin();
		}
	},

	PLUGINS
}
